import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

// Create a custom event system for opening settings
const OPEN_SETTINGS_EVENT = 'openCookieSettings';
export const openCookieSettings = () => {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
};

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [hasAnalytics, setHasAnalytics] = useState(false);

  useEffect(() => {
    console.log('CookieBanner mounted');
    const consent = localStorage.getItem('cookieConsent');
    console.log('Current consent:', consent);
    
    if (consent) {
      const { analytics } = JSON.parse(consent);
      setHasAnalytics(analytics);
      if (analytics && window.gtag) {
        initializeGA();
      }
      setShowBanner(false);
    }

    const handleOpenSettings = () => setShowSettings(true);
    window.addEventListener(OPEN_SETTINGS_EVENT, handleOpenSettings);
    
    return () => {
      window.removeEventListener(OPEN_SETTINGS_EVENT, handleOpenSettings);
    };
  }, []);

  const initializeGA = () => {
    console.log('Initializing GA');
    window.gtag('js', new Date());
    window.gtag('config', 'G-WXBXRD8PNQ');
    window.gtag('config', 'AW-11535953886');
  };

  const disableGA = () => {
    console.log('Disabling GA');
    // Disable GA tracking
    window['ga-disable-G-WXBXRD8PNQ'] = true;
    window['ga-disable-AW-11535953886'] = true;
    
    // Clear any existing cookies
    document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  };

  const handleConsent = (analytics = false) => {
    console.log('Handling consent, analytics:', analytics);
    setHasAnalytics(analytics);
    
    localStorage.setItem('cookieConsent', JSON.stringify({
      analytics,
      timestamp: new Date().toISOString(),
      version: '1.0'
    }));

    if (analytics && window.gtag) {
      initializeGA();
    } else {
      disableGA();
    }

    setShowBanner(false);
    setShowSettings(false);
  };

  if (!showBanner && !showSettings) return null;

  return (
    <>
      {/* Banner */}
      {showBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-lg z-50">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-600">
              Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Mit der Nutzung unserer Website stimmen Sie unserer{' '}
              <a href="/agb#datenschutz" className="underline">Datenschutzerklärung</a> zu.
            </p>
            <div className="flex gap-2">
              <button
                onClick={() => handleConsent(false)}
                className="px-4 py-2 text-sm border border-gray-300 rounded hover:bg-gray-100"
              >
                Ablehnen
              </button>
              <button
                onClick={() => handleConsent(true)}
                className="px-4 py-2 text-sm bg-[#FFA23E] text-white rounded hover:bg-[#FF923E]"
              >
                Akzeptieren
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Settings Modal */}
      {showSettings && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full m-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Cookie-Einstellungen</h2>
              <button onClick={() => setShowSettings(false)} className="p-1">
                <X size={24} />
              </button>
            </div>
            <div className="mb-4">
              <div className="flex items-center justify-between py-2">
                <div>
                  <p className="font-medium">Notwendige Cookies</p>
                  <p className="text-sm text-gray-600">Für grundlegende Funktionen erforderlich</p>
                </div>
                <div className="bg-gray-100 px-3 py-1 rounded">Aktiv</div>
              </div>
              <div className="flex items-center justify-between py-2">
                <div>
                  <p className="font-medium">Analyse Cookies</p>
                  <p className="text-sm text-gray-600">Helfen uns die Website zu verbessern</p>
                </div>
                <button
                  onClick={() => handleConsent(!hasAnalytics)}
                  className={`px-3 py-1 rounded ${
                    hasAnalytics ? 'bg-[#FFA23E] text-white' : 'bg-gray-100'
                  }`}
                >
                  {hasAnalytics ? 'Aktiv' : 'Inaktiv'}
                </button>
              </div>
            </div>
            <button
              onClick={() => setShowSettings(false)}
              className="w-full px-4 py-2 bg-[#FFA23E] text-white rounded hover:bg-[#FF923E]"
            >
              Schließen
            </button>
          </div>
        </div>
      )}
    </>
  );
}
